import React from 'react'

const PageTitle = (props) => {
  return (
    <div className={`page-title ${props.noSpaceBottom ? 'page-title--no-space-bottom' : 'page-title--space-bottom'}`}>
      <h1>{props.title || 'Section name'}</h1>
    </div>
  )
}

export default PageTitle
